import { supabase } from "../lib/supabaseClient";

/**
 * Service de gestion de la newsletter
 */
export const newsletterService = {
  /**
   * Inscrire un email à la newsletter
   * @param {string} email - L'email à inscrire
   * @returns {Promise<{success: boolean, message: string}>}
   */
  async subscribe(email) {
    try {
      // Validation basique de l'email
      if (!email || !email.includes('@')) {
        return {
          success: false,
          message: 'Veuillez entrer une adresse email valide'
        };
      }

      // Insertion dans la table
      const { data, error } = await supabase
        .from('newsletter_subscribers')
        .insert([{ email: email.toLowerCase().trim() }])
        .select()
        .single();

      if (error) {
        // Si l'email existe déjà
        if (error.code === '23505') {
          return {
            success: false,
            message: 'Cet email est déjà inscrit à notre newsletter'
          };
        }

        throw error;
      }

      // Email de bienvenue (best-effort : l'inscription reste valable même si l'envoi échoue).
      supabase.functions
        .invoke('send-newsletter-welcome', {
          body: { email: data.email, unsubscribeToken: data.unsubscribe_token },
        })
        .catch((e) => console.error('Erreur envoi email de bienvenue newsletter:', e));

      return {
        success: true,
        message: 'Inscription réussie ! Vérifiez votre email pour la confirmation.',
        data
      };

    } catch (error) {
      console.error('Erreur lors de l\'inscription:', error);
      return {
        success: false,
        message: 'Une erreur est survenue. Veuillez réessayer.'
      };
    }
  },

  /**
   * Se désinscrire de la newsletter
   * @param {string} token - Le token de désinscription
   */
  async unsubscribe(token) {
    try {
      const { error } = await supabase
        .from('newsletter_subscribers')
        .update({ is_active: false })
        .eq('unsubscribe_token', token);

      if (error) throw error;

      return {
        success: true,
        message: 'Vous avez été désinscrit avec succès'
      };
    } catch (error) {
      console.error('Erreur désinscription:', error);
      return {
        success: false,
        message: 'Erreur lors de la désinscription'
      };
    }
  },

  /**
   * Récupérer tous les abonnés actifs (admin seulement)
   */
  async getActiveSubscribers() {
    try {
      const { data, error } = await supabase
        .from('newsletter_subscribers')
        .select('*')
        .eq('is_active', true)
        .order('subscribed_at', { ascending: false });

      if (error) throw error;

      return { success: true, data };
    } catch (error) {
      console.error('Erreur récupération abonnés:', error);
      return { success: false, message: 'Erreur lors de la récupération' };
    }
  }
};